import Locales from './locales';

const locales = { ...Locales };
const CURRENT_LOCALE =  localStorage.getItem('lang') || 'en';

export default function translate(key) {
    return locales[CURRENT_LOCALE][key] || key;
}